import { ReactElement, cloneElement } from 'react'

interface ModalFooterProps {
    buttons: ReactElement[]
}

function ModalFooter({ buttons }: ModalFooterProps) {
    return (
        <footer className='px-4 py-3 bg-gray-100 flex gap-2 justify-end'>
            {buttons.map((button, index) => cloneElement(button, { key: index }))}
        </footer>
    )
}

export default ModalFooter
